import {
  Checkbox,
  DatePicker,
  Input,
  InputNumber,
  List,
  Popover,
  Select,
  Tabs,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import styled from "styled-components";
import {
  MoreOutlined,
  // PushpinOutlined,
  TableOutlined,
  ColumnWidthOutlined,
} from "@ant-design/icons";
import IconFilter from "assets/icons/common/FilterTable.svg";
import IconCloseFilter from "assets/icons/common/CloseFilter.svg";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { setOpenFilter, setSearchKeyFilters } from "redux/slices/objects";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { BASE_URL_API } from "constants/constants";
import { checkTokenExpiration } from "contexts/TokenCheck";
import axios from "axios";

const { Option } = Select;
const { Text } = Typography;
const menuFreeze = ["Remove Freeze", "Freeze to left", "Freeze to right"];
const menuResize = [
  // "Autosizes this column",
  "Autosizes all columns",
  "Fit all columns",
  "Reset columns",
];

const removeAccents = (str) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

const filterOption = (input, option) =>
  removeAccents(option?.label ?? "")
    .toLowerCase()
    .includes(removeAccents(input.toLowerCase()));

const CustomHeader = (props, ref) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [allKey, setAllKey] = useState([]);
  const [keySearch, setKeySearch] = useState("");
  const [options, setOptions] = useState([]);
  const [dataPicklist, setDataPicklist] = useState(null);
  const { objectGlobalSearch, openFilter, searchKey } = useSelector(
    (state) => state.objectsReducer
  );
  const { pickListParentOptions } = useSelector(
    (state) => state.dropListReducer
  );

  useEffect(() => {
    const loadOptions = async () => {
      const payload = {
        picklist_id: _.get(props, "item.droplist_id"),
      };

      try {
        const token = await checkTokenExpiration();
        const response = await axios.post(
          BASE_URL_API + "picklist/load_listview_picklist",
          payload,
          {
            headers: {
              Authorization: token,
            },
          }
        );

        setDataPicklist(_.get(response, "data.data"));
      } catch (error) {}
    };

    if (_.get(props, "item.droplist_id")) {
      loadOptions();
    }
  }, [props]);

  useEffect(() => {
    if (dataPicklist) {
      const fieldsMapping = _.get(dataPicklist, "field_mapping");
      const dataOptions = _.get(dataPicklist, "data_select").map((item) => {
        return {
          key: _.get(item, `${fieldsMapping.key}.value`),
          value: _.get(item, `${fieldsMapping.value}.value`),
          disabled: _.get(item, `${fieldsMapping.disabled}.value`),
          _id: _.get(item, "_id"),
          parent_record_id: _.get(
            item,
            `${_.get(fieldsMapping, "parent_key")}.id_related_record`
          ),
        };
      });
      setOptions(dataOptions);
    } else {
      setOptions([]);
    }
  }, [dataPicklist]);

  //droplist
  const InputSearh = (ID) => {
    return (
      <CustomSearch
        defaultValue={searchKey[ID] ? searchKey[ID] : null}
        className="filterTable"
        allowClear
        // disabled={objectGlobalSearch.allow_global_search}
        onPressEnter={(value) => {
          let newValue = value.target.value.replace(
            /[^-a-zA-Z0-9aAàÀảẢãÃáÁạẠăĂằẰẳẲẵẴắẮặẶâÂầẦẩẨẫẪấẤậẬbBcCdDđĐeEèÈẻẺẽẼéÉẹẸêÊềỀểỂễỄếẾệỆ fFgGhHiIìÌỉỈĩĨíÍịỊjJkKlLmMnNoOòÒỏỎõÕóÓọỌôÔồỒổỔỗỖốỐộỘơƠờỜởỞỡỠớỚợỢpPqQrRsStTu UùÙủỦũŨúÚụỤưƯừỪửỬữỮứỨựỰvVwWxXyYỳỲỷỶỹỸýÝỵỴzZ-~!@#$%^&*-_\\+\\`\\-\\=\\<\\>\\,\\.\\/\\?\\:\\;\\"\\'\\|\\]/g,
            ""
          );
          props.handleSearch(_.get(props, "item"), newValue);
        }}
        placeholder={`${
          _.get(props, "item.ID") === "owner"
            ? "Assign to"
            : _.get(props, "displayName")
        }`}
      />
    );
  };

  const SelectSearch = (ID) => {
    return (
      <CustomSelect
        maxTagCount="responsive"
        maxTagPlaceholder={(omittedValues) => (
          <Tooltip
            placement="left"
            title={
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: "4px",
                }}
              >
                {omittedValues
                  .map(({ label }) => label)
                  .map((i) => (
                    <Tag style={{ fontSize: 14 }}>{i}</Tag>
                  ))}
              </div>
            }
            overlayStyle={{ maxWidth: "1000px" }}
          >
            <span>+ {_.size(omittedValues)} ...</span>
          </Tooltip>
        )}
        showSearch
        filterOption={filterOption}
        defaultValue={searchKey[ID] ? searchKey[ID] : []}
        className="filterTable"
        mode="multiple"
        allowClear={true}
        onClear={() => {
          // setSearchKey({});
          dispatch(setSearchKeyFilters({}));
        }}
        placeholder={`${
          _.get(props, "item.ID") === "owner"
            ? "Assign to"
            : _.get(props, "displayName")
        }`}
        onChange={(value) => {
          props.handleSearch(
            _.get(props, "item"),
            value.length === 0 ? undefined : value
          );
        }}
        style={{ marginBottom: 8, display: "block" }}
        options={
          pickListParentOptions
            ? pickListParentOptions.map((item) => {
                return {
                  value: _.get(item, "_id"),
                  label: `${_.get(item, "key")} (${_.get(item, "value")})`,
                };
              })
            : []
        }
      />
    );
  };

  const InputHandle = (ID) => {
    return (
      <CustomSearch
        defaultValue={searchKey[ID] ? searchKey[ID] : null}
        className="filterTable"
        allowClear
        onChange={(value) => {
          let newValue = value.target.value.replace(
            /[^-a-zA-Z0-9aAàÀảẢãÃáÁạẠăĂằẰẳẲẵẴắẮặẶâÂầẦẩẨẫẪấẤậẬbBcCdDđĐeEèÈẻẺẽẼéÉẹẸêÊềỀểỂễỄếẾệỆ fFgGhHiIìÌỉỈĩĨíÍịỊjJkKlLmMnNoOòÒỏỎõÕóÓọỌôÔồỒổỔỗỖốỐộỘơƠờỜởỞỡỠớỚợỢpPqQrRsStTu UùÙủỦũŨúÚụỤưƯừỪửỬữỮứỨựỰvVwWxXyYỳỲỷỶỹỸýÝỵỴzZ-~!@#$%^&*-_\\+\\`\\-\\=\\<\\>\\,\\.\\/\\?\\:\\;\\"\\'\\|\\]/g,
            ""
          );
          props.handleChangeListSearch(_.get(props, "item.ID"), newValue);
        }}
        disabled={objectGlobalSearch.allow_global_search}
        onPressEnter={(value) => {
          let newValue = value.target.value.replace(
            /[^-a-zA-Z0-9aAàÀảẢãÃáÁạẠăĂằẰẳẲẵẴắẮặẶâÂầẦẩẨẫẪấẤậẬbBcCdDđĐeEèÈẻẺẽẼéÉẹẸêÊềỀểỂễỄếẾệỆ fFgGhHiIìÌỉỈĩĨíÍịỊjJkKlLmMnNoOòÒỏỎõÕóÓọỌôÔồỒổỔỗỖốỐộỘơƠờỜởỞỡỠớỚợỢpPqQrRsStTu UùÙủỦũŨúÚụỤưƯừỪửỬữỮứỨựỰvVwWxXyYỳỲỷỶỹỸýÝỵỴzZ-~!@#$%^&*-_\\+\\`\\-\\=\\<\\>\\,\\.\\/\\?\\:\\;\\"\\'\\|\\]/g,
            ""
          );
          props.handleSearch(_.get(props, "item"), newValue);
        }}
        placeholder={`${
          _.get(props, "item.ID") === "owner"
            ? "Assign to"
            : _.get(props, "item.name")
        }`}
      />
    );
  };

  const NumberHandle = (ID) => {
    return (
      <CustomSearchNumber
        defaultValue={searchKey[ID] ? Number(searchKey[ID]) : null}
        className="filterTable"
        allowClear
        onChange={(value) => {
          props.handleChangeListSearch(_.get(props, "item.ID"), value);
        }}
        disabled={
          _.get(props, "item.ID") === "created_date" ||
          _.get(props, "item.ID") === "modify_time"
        }
        onPressEnter={(value) => {
          props.handleSearch(
            _.get(props, "item"),
            parseInt(value.target.value)
          );
        }}
        placeholder={`${
          _.get(props, "item.ID") === "owner"
            ? "Assign to"
            : _.get(props, "item.name")
        }`}
      />
    );
  };

  const DateHandle = (ID) => {
    return (
      <CustomDate
        defaultValue={searchKey[ID] ? dayjs(searchKey[ID], "YYYY-MM-DD") : null}
        className="filterTable"
        allowClear
        disabled={objectGlobalSearch.allow_global_search}
        placeholder={`${
          _.get(props, "item.ID") === "owner"
            ? "Assign to"
            : _.get(props, "item.name")
        }`}
        onChange={(date, dateSting) => {
          props.handleSearch(_.get(props, "item"), dateSting);
        }}
      />
    );
  };

  const SelectHandle = (option, ID) => {
    return (
      <CustomSelect
        defaultValue={searchKey[ID] ? searchKey[ID] : []}
        className="filterTable"
        disabled={objectGlobalSearch.allow_global_search}
        showSearch
        mode="multiple"
        allowClear={true}
        onClear={() => {
          // setSearchKey({});
          dispatch(setSearchKeyFilters({}));
        }}
        placeholder={`${
          _.get(props, "item.ID") === "owner"
            ? "Assign to"
            : _.get(props, "item.name")
        }`}
        onChange={(value) => {
          props.handleSearch(
            _.get(props, "item"),
            value.length === 0 ? undefined : value
          );
        }}
        style={{ marginBottom: 8, display: "block" }}
      >
        {option &&
          option.map((op, index) => {
            return (
              <Option key={index} value={op.label}>
                {op.label}
              </Option>
            );
          })}
      </CustomSelect>
    );
  };

  const SelectHandleDroplist = (options, ID) => {
    return (
      <CustomSelect
        filterOption={filterOption}
        defaultValue={searchKey[ID] ? searchKey[ID] : []}
        className="filterTable"
        disabled={objectGlobalSearch.allow_global_search}
        showSearch
        mode="multiple"
        allowClear={true}
        onClear={() => {
          // setSearchKey({});
          dispatch(setSearchKeyFilters({}));
        }}
        placeholder={`${
          _.get(props, "item.ID") === "owner"
            ? "Assign to"
            : _.get(props, "item.name")
        }`}
        onChange={(value) => {
          props.handleSearch(
            _.get(props, "item"),
            value.length === 0 ? undefined : value
          );
        }}
        style={{ marginBottom: 8, display: "block" }}
        options={
          options && _.size(options) > 0
            ? options.map((item) => {
                return {
                  value: _.get(item, "value"),
                  label: _.get(item, "key"),
                };
              })
            : []
        }
      />
    );
  };

  const RenderInput = (type, formula_type, option, ID) => {
    if (type === "inputSearch") {
      if (ID === "parent_record_id") {
        return SelectSearch(ID);
      }
      return InputSearh(ID);
    }

    //input list view
    if (
      type === "date" ||
      type === "datetime-local" ||
      ID === "created_date" ||
      ID === "modify_time"
    ) {
      return DateHandle(ID);
    } else {
      if (type === "droplist") {
        return SelectHandleDroplist(options, ID);
      }

      if (type === "default") return <div></div>;

      if (!type && !ID) return <></>;
      // return <>{/* <button onClick={props.saveState}>Save</button> */}</>;

      if (
        type !== "select" &&
        type !== "dynamic-field" &&
        type !== "number" &&
        type !== "formula"
      ) {
        return InputHandle(ID);
      } else {
        if (
          type === "number" ||
          (type === "formula" && formula_type === "dateToParts") ||
          (type === "formula" && formula_type === "dateDiff") ||
          (type === "formula" && formula_type === "add") ||
          (type === "formula" && formula_type === "subtract") ||
          (type === "formula" && formula_type === "multiply") ||
          (type === "formula" && formula_type === "devide") ||
          (type === "formula" && formula_type === "mod") ||
          (type === "formula" && formula_type === "max") ||
          (type === "formula" && formula_type === "min") ||
          (type === "formula" && formula_type === "advanceExpression")
        ) {
          return NumberHandle(ID);
        } else {
          if (type === "formula") {
            return InputHandle(ID);
          } else {
            return SelectHandle(option, ID);
          }
        }
      }
    }
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const PinCol = useCallback(
    (position) => {
      props.gridRef.current.columnApi.applyColumnState({
        state: [{ colId: _.get(props, "column.colId"), pinned: position }],
      });
    },
    [props]
  );

  const SelectCol = useCallback(
    (id, hidden) => {
      props.gridRef.current.columnApi.applyColumnState({
        state: [{ colId: id, hide: hidden }],
      });
    },
    [props]
  );

  const onChangeHandle = useCallback((e) => {
    setKeySearch(e.target.value);
  }, []);

  const debouncedChangeHandler = useMemo(
    () => _.debounce(onChangeHandle, 300),
    [onChangeHandle]
  );

  // const items = [
  //   {
  //     key: "1",
  //     label: (
  //       <WrapperTab>
  //         <PushpinOutlined style={{ fontSize: 17 }} />
  //       </WrapperTab>
  //     ),
  //     children: (
  //       <CustomList
  //         size="small"
  //         dataSource={menuFreeze}
  //         renderItem={(item, index) => {
  //           if (!props.column.pinned && index === 0) {
  //             return <CustomItem className="disable">{item}</CustomItem>;
  //           }

  //           if (props.column.pinned === "left" && index === 1) {
  //             return <CustomItem className="disable">{item}</CustomItem>;
  //           }

  //           if (props.column.pinned === "right" && index === 2) {
  //             return <CustomItem className="disable">{item}</CustomItem>;
  //           }

  //           return (
  //             <CustomItem
  //               onClick={() => {
  //                 if (index === 0) {
  //                   PinCol(null);
  //                 }

  //                 if (index === 1) {
  //                   PinCol("left");
  //                 }

  //                 if (index === 2) {
  //                   PinCol("right");
  //                 }
  //               }}
  //             >
  //               {item}
  //             </CustomItem>
  //           );
  //         }}
  //       />
  //     ),
  //   },
  // ];

  const itemsActiom = [
    {
      key: "2",
      label: (
        <WrapperTab>
          <TableOutlined style={{ fontSize: 17 }} />
        </WrapperTab>
      ),
      children: (
        <>
          <CustomSearch
            autoFocus
            placeholder="Search..."
            style={{ marginBottom: "4px" }}
            onChange={debouncedChangeHandler}
          />
          <ListCheck>
            {props.cols.map((item) => {
              if (
                keySearch &&
                !item.headerName.toLowerCase().includes(keySearch.toLowerCase())
              ) {
                return null;
              }

              return (
                <CustomCheckbox
                  key={item.field}
                  value={item.field}
                  onChange={(e) => {
                    SelectCol(e.target.value, !e.target.checked);

                    if (allKey.includes(item.field)) {
                      setAllKey((pre) =>
                        pre.filter((key) => key !== e.target.value)
                      );
                    } else {
                      setAllKey((pre) => [...pre, e.target.value]);
                    }
                  }}
                  style={{ marginLeft: "8px" }}
                  checked={allKey.includes(item.field)}
                >
                  <Text
                    ellipsis={{
                      tooltip: item.headerName,
                    }}
                    style={{ maxWidth: "150px" }}
                  >
                    {item.headerName}
                  </Text>
                </CustomCheckbox>
              );
            })}
          </ListCheck>
        </>
      ),
    },
    {
      key: "3",
      label: (
        <WrapperTab>
          <ColumnWidthOutlined style={{ fontSize: 17 }} />
        </WrapperTab>
      ),
      children: (
        <CustomList
          size="small"
          dataSource={menuResize}
          renderItem={(item, index) => (
            <CustomItem
              onClick={() => {
                // if (index === 0) {
                //   props.gridRef.current.columnApi.autoSizeColumn(props.field);
                // }

                if (index === 0) {
                  props.gridRef.current.columnApi.autoSizeAllColumns();
                }

                if (index === 1) {
                  props.gridRef.current.api.sizeColumnsToFit();
                }

                if (index === 2) {
                  props.resetState();
                }
              }}
            >
              {item}
            </CustomItem>
          )}
        />
      ),
    },
  ];

  const content =
    props.field === "_id" ? (
      <CustomTabs
        defaultActiveKey="1"
        type="card"
        items={itemsActiom}
        tabPosition={"left"}
        centered
        animated={true}
      />
    ) : (
      // <>
      //   <CustomSearch
      //     autoFocus
      //     placeholder="Search..."
      //     style={{ marginBottom: "4px" }}
      //     onChange={debouncedChangeHandler}
      //   />
      //   <ListCheck>
      //     {props.cols.map((item) => {
      //       if (
      //         keySearch &&
      //         !item.headerName.toLowerCase().includes(keySearch)
      //       ) {
      //         return null;
      //       }

      //       return (
      //         <CustomCheckbox
      //           key={item.field}
      //           value={item.field}
      //           onChange={(e) => {
      //             SelectCol(e.target.value, !e.target.checked);

      //             if (allKey.includes(item.field)) {
      //               setAllKey((pre) =>
      //                 pre.filter((key) => key !== e.target.value)
      //               );
      //             } else {
      //               setAllKey((pre) => [...pre, e.target.value]);
      //             }
      //           }}
      //           style={{ marginLeft: "8px" }}
      //           checked={allKey.includes(item.field)}
      //         >
      //           <Text
      //             ellipsis={{
      //               tooltip: item.headerName,
      //             }}
      //             style={{ maxWidth: "150px" }}
      //           >
      //             {item.headerName}
      //           </Text>
      //         </CustomCheckbox>
      //       );
      //     })}
      //   </ListCheck>
      // </>
      <CustomList
        size="small"
        dataSource={menuFreeze}
        renderItem={(item, index) => {
          if (!props.column.pinned && index === 0) {
            return <CustomItem className="disable">{item}</CustomItem>;
          }

          if (props.column.pinned === "left" && index === 1) {
            return <CustomItem className="disable">{item}</CustomItem>;
          }

          if (props.column.pinned === "right" && index === 2) {
            return <CustomItem className="disable">{item}</CustomItem>;
          }

          return (
            <CustomItem
              onClick={() => {
                if (index === 0) {
                  PinCol(null);
                }

                if (index === 1) {
                  PinCol("left");
                }

                if (index === 2) {
                  PinCol("right");
                }
              }}
            >
              {item}
            </CustomItem>
          );
        }}
      />
      // <CustomTabs
      //   defaultActiveKey="1"
      //   type="card"
      //   items={items}
      //   tabPosition={"left"}
      //   centered
      //   animated={true}
      // />
    );

  useEffect(() => {
    props.gridRef &&
      setAllKey(
        props.gridRef.current.columnApi
          .getColumnState()
          .filter((item) => !item.hide)
          .map((item) => item.colId)
      );
  }, [open, props]);

  return (
    <div
      className="headerItem"
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Wrapper>
        <Text
          className="header"
          ellipsis={{
            tooltip: props.displayName,
          }}
          style={{ color: "#637381" }}
        >
          {_.get(props, "item.ID") === "owner"
            ? "Assign to"
            : props.displayName}
        </Text>
        {/* {props.field === "_id" && ( */}
        <WrapperIcon>
          {props.field !== "_id" && !_.get(props, "hidenFilter") && (
            <img
              src={openFilter ? IconCloseFilter : IconFilter}
              alt="icon"
              onClick={() => {
                dispatch(setOpenFilter());
              }}
            />
          )}
          {!props.hiddenOptionCol && (
            <Popover
              content={content}
              placement={props.field === "_id" ? "leftTop" : "bottom"}
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
              overlayClassName="popupTableAG"
            >
              <DivMore>
                <MoreOutlined />
              </DivMore>
            </Popover>
          )}
        </WrapperIcon>
        {/* )} */}
      </Wrapper>
      {!_.get(props, "hidenFilter") &&
        RenderInput(
          _.get(props, "item.type"),
          _.get(props, "item.formula_type"),
          _.get(props, "item.option"),
          _.get(props, "item.ID")
        )}
      {/* <CustomSearch /> */}
    </div>
  );
};

export default memo(CustomHeader);

const WrapperIcon = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 2px;

  img {
    cursor: pointer;
  }
`;

const CustomSearchNumber = styled(InputNumber)`
  height: 70%;
  border-radius: 5px;
  width: 100%;
  &:hover,
  &:focus {
    border-color: ${(props) => props.theme.main};
    box-shadow: none;
  }
`;

const CustomSelect = styled(Select)`
  margin-bottom: 0px !important;
  height: 70% !important;

  .ant-select-selection-placeholder {
    font-weight: normal;
  }

  .ant-select-selector {
    height: 100% !important;
    border-radius: 5px !important;

    .ant-select-selection-overflow {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
    }
  }

  &:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: ${(props) => props.theme.main} !important;
    box-shadow: none !important;
  }
`;

const CustomDate = styled(DatePicker)`
  height: 70%;
  width: 100%;
  border-radius: 5px;

  &:hover,
  &:focus {
    border-color: ${(props) => props.theme.main};
    box-shadow: none;
  }
`;

const CustomCheckbox = styled(Checkbox)`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${(props) => props.theme.main};
    border-color: ${(props) => props.theme.main};
  }
`;

const CustomSearch = styled(Input)`
  height: 70%;
  border-radius: 5px;
  &:hover,
  &:focus {
    border-color: ${(props) => props.theme.main} !important;
    box-shadow: none !important;
  }
`;

const ListCheck = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 50vh;
  overflow-y: auto;
`;

const CustomList = styled(List)`
  .ant-list-item:hover {
    background-color: #eee;
  }
`;

const WrapperTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CustomTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin: 0;
    .ant-tabs-nav-wrap {
      .ant-tabs-nav-list {
        .ant-tabs-tab {
          padding: 8px;
        }
      }
    }
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(props) => props.theme.main};
    text-shadow: 0 0 0.25px currentcolor;
  }

  .ant-tabs-tab .ant-tabs-tab-btn {
    margin-left: 10px;
  }

  .ant-tabs-content-holder {
    .ant-tabs-content {
      .ant-tabs-tabpane {
        padding-left: 8px;
      }
    }
  }
`;

const CustomItem = styled(List.Item)`
  cursor: pointer;
  .ant-list-sm .ant-list-item {
    padding: 8px 0;
  }

  &.disable {
    cursor: not-allowed;
    opacity: 0.3;
  }
`;

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  position: relative;

  .header {
    font-size: 16px !important;
    font-family: var(--roboto-500) !important;
    color: #252424;
    font-weight: normal !important;
  }
`;

const DivMore = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  cursor: pointer;
  /* position: absolute; */
  /* right: 0; */

  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;

  &:hover {
    background-color: #ddd;
  }
`;
